export const ENTER_SITE = 'enterSite'
export const EXIT_SITE = 'exitSite'

export const GET_MARKETS = 'claim/getMarkets'
export const GET_FILTERS = 'reports/getFiltersData'

export const VIEW_REPORT = 'viewReportAction'
export const SCHEDULE_REPORT = 'scheduleReportAction'
export const CLOSE_REPORT = 'closeReportAction'
